import { createContext, useContext } from 'react';

export const FormValidationContext = createContext(false);

export const useFormValidated = () => useContext(FormValidationContext);